import { Card, CardContent } from '@/components/ui/card';
import { Calendar, MapPin, GraduationCap, Briefcase } from 'lucide-react';

const BiographySection = () => {
  return (
    <section id="biographie" className="py-20 bg-gradient-card">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* En-tête de section */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
              Biographie
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Découvrez le parcours exceptionnel de Bassirou Diomaye Faye, 
              de ses origines à Ndiaganiao jusqu'à la Présidence de la République.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Photo et informations de base */}
            <div className="space-y-6">
              <div className="relative">
                <img 
                  src="/images/president_portrait_4.png" 
                  alt="Bassirou Diomaye Faye" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-card"
                />
                <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary/10 rounded-full blur-xl"></div>
              </div>

              {/* Informations personnelles */}
              <Card className="shadow-card">
                <CardContent className="p-6">
                  <h3 className="text-xl font-semibold mb-4 text-primary">Informations personnelles</h3>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <Calendar className="w-5 h-5 text-secondary" />
                      <span><strong>Né le :</strong> 25 mars 1980</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <MapPin className="w-5 h-5 text-secondary" />
                      <span><strong>Lieu de naissance :</strong> Ndiaganiao, Département de M'bour</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <Briefcase className="w-5 h-5 text-secondary" />
                      <span><strong>Profession :</strong> Inspecteur des finances publiques</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <GraduationCap className="w-5 h-5 text-secondary" />
                      <span><strong>Formation :</strong> Université Cheikh Anta Diop, École Nationale d'Administration</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Récit biographique */}
            <div className="space-y-6">
              <Card className="shadow-card">
                <CardContent className="p-8">
                  <h3 className="text-2xl font-semibold mb-6 text-primary">Origines et formation</h3>
                  <div className="space-y-4 text-muted-foreground leading-relaxed">
                    <p>
                      Bassirou Diomaye Diakhar Faye naît le 25 mars 1980 à Ndiaganiao, 
                      une commune du département de M'bour dans la région de Thiès. 
                      Il grandit dans une famille modeste et fait ses premières études 
                      à l'École catholique Marie médiatrice de Ndiaganiao.
                    </p>
                    <p>
                      Brillant élève, il poursuit ses études secondaires au CEM de Ndiaganiao 
                      avant d'intégrer l'Université Cheikh Anta Diop de Dakar où il étudie le droit. 
                      Sa soif de connaissance et son excellence académique le mènent ensuite 
                      à l'École Nationale d'Administration (ENA) de Dakar.
                    </p>
                    <p>
                      Diplômé de l'ENA, il devient inspecteur des finances publiques, 
                      un poste qui lui permet d'acquérir une expertise approfondie 
                      de la gestion des finances de l'État et des enjeux économiques du pays.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="shadow-card">
                <CardContent className="p-8">
                  <h3 className="text-2xl font-semibold mb-6 text-primary">Engagement politique</h3>
                  <div className="space-y-4 text-muted-foreground leading-relaxed">
                    <p>
                      Son engagement politique débute avec sa rencontre avec Ousmane Sonko 
                      et son adhésion au parti PASTEF (Patriotes Africains du Sénégal pour le Travail, 
                      l'Éthique et la Fraternité). Il devient rapidement secrétaire général du parti, 
                      s'occupant de l'organisation et de la doctrine politique.
                    </p>
                    <p>
                      Reconnu pour son intégrité et sa compétence, il est choisi comme candidat 
                      du PASTEF à l'élection présidentielle de 2024, après la disqualification 
                      d'Ousmane Sonko. Sa campagne, axée sur la rupture et la transformation, 
                      séduit une large partie de l'électorat sénégalais.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BiographySection;